const schoolstowatch = "schoolstowatch";
const today = new Date();

export const newSchoolsToWatch = (data) => {
  const added = "STW_ADDED";
  const adding = "STW_ADDING";
  const ERROR = "STW_ADD_ERROR";
  const clearStatus = "STW_ADD_CLEAR_STATUS";

  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();

    const currentTime = firebase.firestore.Timestamp.fromDate(today);
    const stwRef = firestore.collection(schoolstowatch).doc(data.id);

    const toPartnersFirestore = {
      id: data.id,
      school: data.school,
      year: null,
      videoURL: data.videoURL,
      fileName: data.fileName,
      modifiedAt: currentTime,
    };
    batch.set(stwRef, toPartnersFirestore, { merge: true });

    !data.file && dispatch({ type: adding });

    batch
      .commit()
      .then(() => {
        if (data.file) {
          const storageRef = firebase.storage().ref();
          const uploadRef = storageRef
            .child(schoolstowatch)
            .child(`${data.id}_${data.fileName}`);

          return uploadRef.put(data.file).on(
            "state_changed",

            () => {
              dispatch({ type: adding });
            },

            (error) => {
              dispatch({ type: ERROR, error });
            },

            () => {
              uploadRef
                .getDownloadURL()
                .then(function (downloadURL) {
                  const skillThumbnail = {
                    fileURL: downloadURL,
                  };

                  const batch = firestore.batch();
                  batch.update(stwRef, skillThumbnail);
                  batch
                    .commit()
                    .then(() => {
                      dispatch({ type: added });
                      dispatch({ type: clearStatus });
                    })
                    .catch((err) => {
                      dispatch({ type: ERROR, err });
                    });
                })
                .catch((err) => {
                  dispatch({ type: ERROR, err });
                });
            }
          );
        } else {
          dispatch({ type: added });
          dispatch({ type: clearStatus });
        }
      })
      .catch((e) => {
        dispatch({ type: ERROR, err: e });
      });
  };
};

export const deleteSchoolsToWatch = (id, fileName) => {
  return (dispatch, not, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const stwRef = firestore.collection(schoolstowatch).doc(id);

    stwRef.delete().then(() => {
      if (fileName) {
        const storageRef = firebase.storage().ref();

        const uploadRef = storageRef
          .child(schoolstowatch)
          .child(`${id}_${fileName}`);
        uploadRef.delete();
      }
    });
  };
};
